import * as Immutable from "immutable";

export const questionsPageMap = Immutable.Map({
  pageSize: 25,
  searchQuery: "",
  checked: new Set(),
  checkedAll: false,
  checkedDeep: false,
  elementIndex: null,
  originFilter: "",

  /** @type {null|string} Selected substring of a question to train */
  mouseSelection: null,
  /** @type {null|number} index of the first char of the substring */
  mouseSelectionOffset: null
});

export const questionsPage = (state = questionsPageMap, action) => {
  switch (action.type) {
    case "SET_EXPRESSIONS_LIST":
      return state.merge(action.payload);

    case "TRAIN_EXPRESSION_SUCCESS":
    case "PATCH_EXPRESSION_SUCCESS":
    case "MOVE_EXPRESSION_SUCCESS":
    case "TRAIN_EXPRESSIONS_SUCCESS":
    case "DELETE_UNTRAINED_EXPRESSIONS_SUCCESS":
    case "DELETE_EXPRESSION_SUCCESS":
      return state.merge({
        checked: new Set(),
        checkedAll: false,
        checkedDeep: false,
        mouseSelection: null,
        mouseSelectionOffset: null,
        elementIndex: null
      });

    case "GET_EXPRESSIONS_SUCCESS":
      return state.merge({
        originFilter: action.origin
      });

    default:
      return state;
  }
};
